import request from 'superagent';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import { getBearerGrantTypeAuthHeaders } from '../helpers/auth_helpers';
import client from './rest/AdminClient';

function uploadFilePublic(key, type, file) {
  request
    .post(API_HOST + '/api/v2/documents')
    .set('Authorization', getBearerGrantTypeAuthHeaders())
    .field('name', file.name)
    .field('type', type)
    .field('bucketType', file.bucketType)
    .attach('file', file)
    .end((_err, response) => {
      if (response.body.success) {
        const doc = Object.assign(
          {},
          {
            id: response.body.id,
            uri: response.body.id,
            uri_type: file.bucketType,
          },
          { type },
        );
        AdminServerActionCreators.receiveDocument(key, doc);
      }
    });
}

const bulkDownloadByReferenceNumbers = (
  referenceNumbers,
  types,
  emails,
  languageCodeId,
) =>
  client({
    method: 'POST',
    path: `/api/documents/bulk-download/shipments`,
    entity: JSON.stringify({
      referenceNumbers,
      types,
      emails,
      languageCodeId,
    }),
  });

const bulkDownloadInvoicesByNumbers = (
  invoiceNumbers,
  emails,
  languageCodeId,
) =>
  client({
    method: 'POST',
    path: `/api/documents/bulk-download/invoices`,
    entity: JSON.stringify({
      invoiceNumbers,
      emails,
      languageCodeId,
    }),
  });

const bulkDownloadPayoutsByNumbers = (payoutNumbers, emails, languageCodeId) =>
  client({
    method: 'POST',
    path: `/api/documents/bulk-download/payouts`,
    entity: JSON.stringify({
      payoutNumbers,
      emails,
      languageCodeId,
    }),
  });

export default {
  uploadFilePublic,
  bulkDownloadByReferenceNumbers,
  bulkDownloadInvoicesByNumbers,
  bulkDownloadPayoutsByNumbers,
};
